var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6655_107622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15615 7.593L3.54615 7.206C3.11908 6.82264 2.7835 6.34832 2.56415 5.818C2.86244 5.11926 3.35126 4.51851 3.97477 4.08439C4.59827 3.65028 5.33132 3.40029 6.09015 3.363C6.46235 3.36906 6.831 3.43664 7.18115 3.563L7.59915 3.134C7.12128 2.93218 6.60884 2.82486 6.09015 2.818C5.20133 2.85154 4.34181 3.14473 3.61778 3.66136C2.89375 4.17799 2.33695 4.89542 2.01615 5.725C1.99462 5.78479 1.99462 5.85021 2.01615 5.91C2.25837 6.55292 2.64897 7.12956 3.15615 7.593Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99867 5.745L6.00768 4.736L6.50167 4.236C6.2249 4.16278 5.93375 4.16347 5.65733 4.23801C5.38091 4.31254 5.12888 4.45832 4.92644 4.66076C4.724 4.8632 4.57822 5.11523 4.50369 5.39165C4.42915 5.66808 4.42845 5.95922 4.50167 6.236L4.99867 5.745Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1664 5.725C9.85286 4.91185 9.30856 4.20803 8.60044 3.7L9.90944 2.385L9.52544 2L2.27344 9.252L2.65844 9.637L4.04844 8.245C4.66864 8.60896 5.37242 8.80635 6.09144 8.818C6.98043 8.78466 7.84017 8.49155 8.56439 7.97491C9.28861 7.45827 9.84557 6.74074 10.1664 5.911C10.1882 5.85091 10.1882 5.78509 10.1664 5.725ZM6.09144 8.273C5.51939 8.26292 4.9582 8.11508 4.45544 7.842L5.14844 7.149C5.46347 7.36785 5.84538 7.46905 6.22744 7.43491C6.60951 7.40077 6.96743 7.23346 7.23866 6.96223C7.5099 6.69099 7.67721 6.33307 7.71135 5.95101C7.74549 5.56894 7.64429 5.18703 7.42544 4.872L8.20844 4.089C8.83424 4.5185 9.32361 5.11859 9.61844 5.818C9.32007 6.51689 8.83109 7.11773 8.2074 7.55186C7.5837 7.98599 6.85044 8.23589 6.09144 8.273Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6655_107622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 7.636,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide1);
export default __webpack_public_path__ + "static/media/Hide1.9ed03ea47d1953ae3095b2788152e6b7.svg";
export { ForwardRef as ReactComponent };